import { BehaviorSubject, Observable, of } from 'rxjs';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UploadService } from 'src/app/core/services/upload.service';
import { catchError, filter, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent {

  @Input()
  set src(src: string) {
    this.src$.next(src);
    this.showOriginalImage$.next(false);
    this.loaded$.next(false);
  }
  @Input() placeholder = true;
  @Input() icon?: string;
  @Input()
  set path(path: string) {
    this.path$.next(path);
    this.loaded$.next(false);
  }

  src$ = new BehaviorSubject<string | null>(null);
  path$ = new BehaviorSubject<string | null>(null);
  thumbnailSrc$ = this.getThumbnailSrc();
  loaded$ = new BehaviorSubject(false);
  showOriginalImage$ = new BehaviorSubject(false);

  constructor(
    private uploadService: UploadService
  ) { }

  private getThumbnailSrc(): Observable<string> {
    return this.path$.pipe(
      filter(path => !!path),
      switchMap(path => this.uploadService.getThumbnailURL(path).pipe(
        catchError(err => {
          this.showOriginalImage$.next(true);
          return of(null);
        })
      ))
    );
  }

}
